module.exports = __webpack_public_path__ + "static/media/feelgood-icon.1e5d74d0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onboard/feelgood-icon.svg
// module id = 573
// module chunks = 0